import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Button, Form, Select, Popover, DatePicker, Space, Input } from 'antd';
import { getBOMTranscationStatus } from '../../constance/dataTypes';
import { URL_BOM } from '../../constance/urls';
import { PATH } from '../../routes/Routes';
import { ellipsisString } from '../../utils/stringFormat';
import TSTable from '../common/TSTable';
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from "../../constance/strings"
import dayjs from 'dayjs';
import { useDebounce } from 'use-debounce';
import ColorButton from '../common/ColorButton';
import { BLUE_COLOR } from '../../constance/color';

const { Option } = Select;

export default function BOMList(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const tableRef = React.useRef();
  const [form] = Form.useForm();
  const date = Form.useWatch('date', form)
  const statusFilter = Form.useWatch("status", form)
  const searchText = Form.useWatch("search", form)
  const [debouncedText] = useDebounce(searchText, 500);
  const formattedDate = date ? dayjs(date).format(DATE_FORMAT) : null;

  const columns = React.useMemo(() => [
    {
      title: t('date'),
      dataIndex: 'date',
      render: (text) => new Date(text).toLocaleString('en-GB'),
    },
    {
      title: t('bom_transactions.order_no'),
      dataIndex: 'order_no',
    },
    {
      title: t('bom_transactions.description'),
      dataIndex: 'description',
      render: (text) => (
        <Popover
          trigger="hover"
          content={text}
          inverted
          placement="topLeft"
        >
          <div>{ellipsisString(text)}</div>
        </Popover>
      ),
    },
    {
      title: t('status'),
      render: (text, record) => t(`bom_transactions.statuses.${getBOMTranscationStatus(record)}`),
    },
    {
      title: () => null,
      dataIndex: 'id',
      render: (text, record) => (
        <div style={{ textAlign: 'center' }}>
          <ColorButton
            variant="outlined"
            color='primary'
            override={BLUE_COLOR}
            onClick={() => history.push(`${PATH.BOM}${record.id}`)}>
            {t('detail')}
          </ColorButton>
        </div>
      ),
    },
  ], [statusFilter, date]);


  React.useEffect(() => {
    if (tableRef.current || debouncedText)  {
      tableRef.current.fetch();
    }
  }, [date, statusFilter, debouncedText])

  return (
    <div>
      <Form form={form} >
        <Space style={{ width: '100%', textAlign: 'left' }} >
          <Form.Item label={t('searchs.fields.date')} name={'date'}>
            <DatePicker
              format={HUMAN_DATE_FORMAT}
              placeholder={t('searchs.fields.date')}
              style={{ width: 200 }}
            />
          </Form.Item>

          <Form.Item label={t('status')} name={'status'} >
            <Select
              defaultValue={'ALL'}
              style={{ width: 200 }}
            >
              <Select.Option value="ALL">{t('datas.total')}</Select.Option>
              <Select.Option value="DRAFT">{t('bom_transactions.statuses.draft')}</Select.Option>
              <Select.Option value="COMPLETED">{t('bom_transactions.statuses.completed')}</Select.Option>
              <Select.Option value="INTERFACED">{t('bom_transactions.statuses.interfaced')}</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item label={t('search')} name={"search"}>
            <Input
              placeholder={t('search')}
              allowClear
            />
          </Form.Item>
        </Space>
      </Form>

      <TSTable
        ref={tableRef}
        url={URL_BOM.BOM_TRANSACTION}
        columns={columns}
        params={{
          date: formattedDate,
          status: statusFilter,
          search: searchText
        }}
      />
    </div >
  );
}
